<div>
  <!-- <div class="form-group">
  <span><button class="btn btn-primary" name="View" value="View" [routerLink]="['/maintenance/student-group']">learner group maint</button></span>
</div> -->
@if (media.isActive('xs')) {
  <div>
    <!-- Restored 2026-08-18. Withdrawn on 08-13 because GroupBoardApi's POST /Session/Search applied
         NO authorisation — its only unconditional predicate was `s.IsHidden = 0`, so any authenticated
         DC principal could search every session on the platform, including by a participant's name.
         Search is now scoped server-side (DigitalClassroomAPI@a95d7f7): ApiUser/SuperUser and
         unscoped Admins see everything, a client-scoped Admin sees that client's rooms, and everyone
         else only rooms they belong to.
         ⚠️ This tile launches as a SuperUser, so it is deliberately gated on VideoLibraryAllRooms —
         internal staff only. Do not widen that gate to LaunchVideoLibrary, which is held far more
         broadly and only ever granted one room's recordings.
         Outside the tab group on purpose: as a fourth tab it would be something you have to go
         looking for, which defeats the point. -->
    <video-library-tile></video-library-tile>
    <mat-tab-group>
      <!-- matTabContent defers each tile until its tab is first opened. Without it every tab's
           component is created on load, so all three fire their fetches immediately — the user waits
           on two searches they cannot see. Only the selected tab should cost anything. -->
      <mat-tab label="Actions">
        <ng-template matTabContent>
          <actions-tile [actionDataParams]="actionDataParams" class="grid-primary" [displayall]="true" *checkFeatureRender="'ActionsView'"></actions-tile>
        </ng-template>
      </mat-tab>
      <mat-tab label="Missing Submissions">
        <ng-template matTabContent>
          <missing-submissions [displayall]="true" class="grid-secondary" *checkFeatureRender="'MissingSubmissionsView'"></missing-submissions>
        </ng-template>
      </mat-tab>
      <mat-tab label="Sessions Today">
        <ng-template matTabContent>
          <student-sessions-tile [sessionTileParams]="sessionTileParams" class="grid-secondary" *checkFeatureRender="'StudentSessionsView'"></student-sessions-tile>
        </ng-template>
      </mat-tab>
      <!--<mat-tab label="Sessions Tomorrow"><student-sessions-tile [sessionTileParams]="sessionDataTomorrow" class="grid-secondary" *checkFeatureRender="'StudentSessionsView'"></student-sessions-tile></mat-tab>-->
    </mat-tab-group>
  </div>
}
@if (! media.isActive('xs')) {
  <div>
    <!-- Restored 2026-08-18 now the DC search is scoped — see the note in the mobile block above.
         Renders nothing for users without VideoLibraryAllRooms, so it costs them no space. -->
    <video-library-tile class="grid-secondary"></video-library-tile>
    <div class="margin-top-50">
      <actions-tile [actionDataParams]="actionDataParams" [displayall]="true" class="grid-primary" *checkFeatureRender="'ActionsView'"></actions-tile>
    </div>
    <missing-submissions [displayall]="true" [showHeader]="true" class="grid-secondary" *checkFeatureRender="'MissingSubmissionsView'"></missing-submissions>
    <student-sessions-tile [sessionTileParams]="sessionTileParams" class="grid-secondary" *checkFeatureRender="'StudentSessionsView'"></student-sessions-tile>
    <!--<student-sessions-tile [sessionTileParams]="sessionDataTomorrow" class="grid-secondary" *checkFeatureRender="'StudentSessionsView'"></student-sessions-tile>-->
  </div>
}
</div>
